import React, { useRef, useEffect, useState } from 'react';
import { Button, Tooltip, message, Modal } from 'antd';
import { 
  EyeOutlined, 
  CrownOutlined, 
  DownloadOutlined,
  ArrowLeftOutlined ,
  ExclamationCircleOutlined,
  MenuOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import SideScreen, {generateContent} from '../Components/SideScreen';
import SlideScreen from '../Components/SlideScreen';
import { useSelector } from 'react-redux';
import domtoimage from 'dom-to-image';
import * as htmlToImage from 'html-to-image';
import { useNavigate } from 'react-router-dom';
import { fetchUserData, auth, updateUserTrial } from '../firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import FontFaceObserver from 'fontfaceobserver';
import { changeTrial, updateSlideContent } from '../Store/allreducer';
import { useDispatch } from 'react-redux';



// const useIsPortrait = () => {
//   const [isPortrait, setIsPortrait] = useState(
//     window.innerWidth < 768 && window.innerHeight > window.innerWidth
//   );

//   useEffect(() => {
//     const checkOrientation = () => {
//       setIsPortrait(
//         window.innerWidth < 768 && window.innerHeight > window.innerWidth
//       );
//     };

//     window.addEventListener('resize', checkOrientation);
//     return () => window.removeEventListener('resize', checkOrientation);
//   }, []);

//   return isPortrait;
// };

const EditScreen = () => {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);

  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { slideCount, template, fontStyles, backgroundDesign,showFaintBackgroundImages, currentColorPalletes, subscription, trial, faintBackgroundImageUrl} = useSelector(
    (state) => state.counter,
  );
  const [showRotateModal, setShowRotateModal] = useState(false);
  // const isPortrait = useIsPortrait();
  const [taglineFont, paragraphFont] = fontStyles.split(" + ");
//  console.log('template from edit screen:',template);
  const fetchUserDetails = async () => {
      const userData = await fetchUserData();
   //   console.log('userData from edit screen:',userData);
      setUserData(userData);
      await dispatch(changeTrial(userData?.trial));
  //  console.log('userData from edit screen:',userData);
  }
  useEffect(() => {
    const handleResize = () => {
      
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if(window.innerWidth < 768){
      handleFirstRender();
    }
  }, []);
  
useEffect(() => {
  const init = async () => {
    try {
      await fetchUserDetails();
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };
  
  init();
}, []);
useEffect(() => {
  // Set up auth state observer
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (!user) {
      // No user is signed in, redirect to login
      navigate('/signin');
      return;
    }

    // User is signed in, now safe to fetch user data
    try {
      setIsLoading(true);
      const data = await fetchUserData();
      console.log('userDatas from edit screen:', data, subscription);
      setUserData(data);
    } catch (error) {
      console.error('Error fetching user details:', error);
    } finally {
      setIsLoading(false);
    }
  });

  // Cleanup subscription
  return () => unsubscribe();
}, [subscription, navigate]);


const handleFirstRender = async () =>{
  try {
    const content = await generateContent('A carousel about the benefits of using our product', 5);
    //console.log('Generated content:', content); // Debug log
    
    // Dispatch the content update
    dispatch(updateSlideContent(content));
    
   // message.destroy();
    //message.success('Content generated successfully!');
  } catch (error) {
    console.error('Error generating content:', error);
   // message.destroy();
   // message.error('Failed to generate content. Please try again.');
  }
}

// useEffect(() => {
//   if (isPortrait) {
//     setShowRotateModal(true);
//     const timer = setTimeout(() => {
//       setShowRotateModal(false);
//     }, 5000);
//     return () => clearTimeout(timer);
//   }
// }, [isPortrait]);

  // const exportToPDF = async () => {
  //   try {
  //     message.loading('Generating PDF...', 0);
  //     const slides = document.querySelectorAll('.bgra.relative');
      
  //     // Convert mm to points (1mm = 2.83465 points)
  //     const width = 286 * 2.83465;  // 810.31 points
  //     const height = 357 * 2.83465; // 1012.97 points

  //     const pdf = new jsPDF({
  //       orientation: 'portrait',
  //       unit: 'pt',  // Changed to points for better precision
  //       format: [width, height]
  //     });

  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     for (let i = 0; i < slides.length; i++) {
  //       const slide = slides[i];
        
  //       const wrapper = document.createElement('div');
  //       const wrapperId = `pdf-wrapper-${i}`;
  //       wrapper.id = wrapperId;
        
  //       // Set exact dimensions matching PDF page size
  //       wrapper.style.width = `${pageWidth}px`;
  //       wrapper.style.height = `${pageHeight}px`;
  //       wrapper.style.position = 'absolute';
  //       wrapper.style.left = '-9999px';
  //       wrapper.style.backgroundColor = window.getComputedStyle(slide).backgroundColor;
        


  //       const slideClone = slide.cloneNode(true);
  //       const settingsBox = slideClone.querySelector('.settings-box');
  //       if (settingsBox) {
  //         settingsBox.remove();
  //       }

  //       // Ensure proper scaling
  //       slideClone.style.width = '100%';
  //       slideClone.style.height = '100%';
  //       slideClone.style.margin = '0';
  //       slideClone.style.padding = '0';
  //       slideClone.style.transform = 'none';
        

  //       wrapper.appendChild(slideClone);
  //       document.body.appendChild(wrapper);

  //       const canvas = await html2canvas(wrapper, {
  //         scale: 3, // Increased for better quality
  //         useCORS: true,
  //         logging: false,
  //         allowTaint: true,
  //         backgroundColor: null,
  //         width: pageWidth,
  //         height: pageHeight,
  //         imageTimeout: 0, // Wait for all images
  //         onclone: (clonedDoc) => {
  //           const clonedWrapper = clonedDoc.getElementById(wrapperId);
  //           if (clonedWrapper) {
  //             const clonedSlide = clonedWrapper.firstChild;
  //             if (clonedSlide) {
  //               clonedSlide.style.width = '100%';
  //               clonedSlide.style.height = '100%';
  //               clonedSlide.style.transform = 'none';
  //             }
  //           }
  //         }
  //       });

  //       if (i > 0) {
  //         pdf.addPage();
  //       }

  //       // Use higher quality JPEG compression
  //       const imgData = canvas.toDataURL('image/jpeg', 1.0);
        
  //       // Add image with proper positioning and scaling
  //       pdf.addImage(imgData, 'JPEG', 0, 0, pageWidth, pageHeight, undefined, 'FAST');

  //       document.body.removeChild(wrapper);
  //     }

  //     pdf.save('carousel-slides.pdf');
  //     message.destroy();
  //     message.success('PDF exported successfully!');
  //   } catch (error) {
  //     console.error('Error exporting PDF:', error);
  //     message.destroy();
  //     message.error('Failed to export PDF. Please try again.');
  //   }
  // };

  // const exportToPDFUsingDomToImage = async () => {
  //   try {
  //     message.loading('Generating PDF...', 0);
  //     const slides = document.querySelectorAll('.bgra.relative');
      
  //     // Convert mm to points (1mm = 2.83465 points)
  //     const width = 286 * 2.83465;  // 810.31 points
  //     const height = 357 * 2.83465; // 1012.97 points

  //     const pdf = new jsPDF({
  //       orientation: 'portrait',
  //       unit: 'pt',
  //       format: [width, height]
  //     });

  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     // Process slides one by one
  //     for (let i = 0; i < slides.length; i++) {
  //       const slide = slides[i];
        
  //       // Create a container div with specific styling
  //       const container = document.createElement('div');
  //       container.style.cssText = `
  //         position: fixed;
  //         top: 0;
  //         left: 0;
  //         width: ${pageWidth}px;
  //         height: ${pageHeight}px;
  //         background-color: ${window.getComputedStyle(slide).backgroundColor};
  //         z-index: -9999;
  //       `;

  //       // Clone the slide and prepare it
  //       const slideClone = slide.cloneNode(true);
  //      // console.log('slideClone:',slideClone);
  //       // Remove settings box if present
  //       const settingsBox = slideClone.querySelector('.settings-box');
  //       if (settingsBox) {
  //         settingsBox.remove();
  //       }

  //       // Style the cloned slide
  //       slideClone.style.cssText = `
  //         width: 100%;
  //         height: 100%;
  //         margin: 0;
  //         padding: 0;
  //         transform: none;
  //         position: relative;
  //         overflow: hidden;
  //       `;

  //       // Append elements
  //       container.appendChild(slideClone);
  //       document.body.appendChild(container);

  //       // Wait for a moment to ensure rendering
  //       await new Promise(resolve => setTimeout(resolve, 100));

  //       try {
  //         // Capture the slide
  //         const dataUrl = await domtoimage.toJpeg(container, {
  //           width: pageWidth,
  //           height: pageHeight,
  //           style: {

  //             transform: 'scale(1)',
  //             'transform-origin': 'top left'
  //           },
  //           quality: 1.0
  //         });
  //       //  console.log('dataUrl:',dataUrl);
  //         // Add new page if not first slide
  //         if (i > 0) {
  //           pdf.addPage();
  //         }

  //         // Add to PDF
  //         pdf.addImage(
  //           dataUrl,
  //           'JPEG',
  //           0,
  //           0,
  //           pageWidth,
  //           pageHeight,
  //           undefined,
  //           'FAST'

  //         );

  //         // Cleanup
  //         document.body.removeChild(container);
  //       } catch (error) {
  //         console.error('Error capturing slide:', error);
  //         document.body.removeChild(container);
  //       }
  //     }

  //     // Save the PDF
  //     pdf.save('carousel-slides.pdf');
  //     message.destroy();
  //     message.success('PDF exported successfully!');
  //   } catch (error) {
  //     console.error('Error exporting PDF:', error);
  //     message.destroy();
  //     message.error('Failed to export PDF. Please try again.');
  //   }
  // };

  const getFontEmbedCSS = async () => {
    const fontUrls = [
      `https://fonts.googleapis.com/css2?family=${taglineFont.replace(/ /g, "+")}:wght@400;700`,
      `https://fonts.googleapis.com/css2?family=${paragraphFont.replace(/ /g, "+")}:wght@400;700`
    ];
  
    const cssTexts = await Promise.all(
      fontUrls.map(url => 
        fetch(url)
          .then(response => response.text())
      )
    );
    console.log('cssTexts:',cssTexts);
    return cssTexts.join('\n');
  };

  
    const loadFont = async (font) => {
      const link = document.createElement("link");
      link.href = `https://fonts.googleapis.com/css2?family=${font.replace(/ /g, "+")}:wght@400;700&display=swap`;
      link.rel = "stylesheet";
      link.crossOrigin = "anonymous";
      
      return link; // Cleanup
    };
    const loadFont2 = async (url) => {
      try {
        const cacheBuster = `&t=${new Date().getTime()}`;
        const response = await fetch(url + cacheBuster);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        
        let css = await response.text();
        return css.replace(/}/g, 'font-display: swap; }');
      } catch (error) {
        console.error('Error loading font:', error);
        return null;
      }
    };

   const onlyRemove = (taglineFontCSS, paragraphFontCSS) => {
    if (taglineFontCSS) {
      let existingStyle = document.head.querySelectorAll(`.tagStyle`);
      let existingStyle2 = document.querySelectorAll(`.tagStyle`);
      console.log('existingStyle:',existingStyle, 'existingStyle2:',existingStyle2, typeof existingStyle, typeof existingStyle2);
      if (existingStyle.length > 0) {
        existingStyle.forEach(style => style.remove()); // Remove existing style if found
      }
      if (existingStyle2.length > 0) {
        existingStyle2.forEach(style => style.remove()); // Remove existing style if found
      }
      
    }
  
    if (paragraphFontCSS) {
      let existingStyle = document.head.querySelectorAll(`.paraStyle`);
      let existingStyle2 = document.querySelectorAll(`.paraStyle`);
      console.log('existingStyle:',existingStyle, 'existingStyle2:',existingStyle2);
      if (existingStyle.length > 0) {
        existingStyle.forEach(style => style.remove()); // Remove existing style if found
      }
      if (existingStyle2.length > 0) {
        existingStyle2.forEach(style => style.remove()); // Remove existing style if found
      }
      
    }
   }
  const exportToPDFUsingHtmlToImage = async () => {
    try {
      message.loading('Generating PDF...', 0);
      // if(!userData.subscription){
      //   const newTrial = trial - 1; 
      //   if(trial===0){
      //     message.destroy();
      //     message.error('Trial expired. Please subscribe to continue.');
      //     navigate('/settings');
      //     return;
      //   }
      //   await updateUserTrial(newTrial);
      //   await dispatch(changeTrial(newTrial));
      // }
      
      const slides = document.querySelectorAll('.bgra.relative');
      
      // Convert mm to points (1mm = 2.83465 points)
      const width = 286*1.6 ;  // 810.31 points
      const height = 347*1.6 ; // 1012.97 points

      


      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [width, height]
      });


      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
    // console.log('pageWidth:',pageWidth, width);
    // console.log('pageHeight:',pageHeight, height);
    
       // const link1 = await loadFont(taglineFont);
        //const link2 = await loadFont(paragraphFont);
        const taglineFontCSS = await loadFont2(`https://fonts.googleapis.com/css2?family=${taglineFont.replace(/ /g, "+")}:wght@400;700&display=swap`);
        const paragraphFontCSS = await loadFont2(`https://fonts.googleapis.com/css2?family=${paragraphFont.replace(/ /g, "+")}:wght@400;700&display=swap`);
       // console.log('link1:',link1, 'link2:',link2);
       
      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];
        
     
        // Create container for the slide
        const container = document.createElement('div');
        container.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          width: ${pageWidth}px;
          height: ${pageHeight}px;
          background-color: ${window.getComputedStyle(slide).backgroundColor};
          z-index: -9999;

        `;


        // Clone and prepare slide
        const slideClone = slide.cloneNode(true);
        const patternLayer = slideClone.querySelector('.pattern_layer')
      //  console.log('slideClone:', slideClone);
        // const settingsBox = slideClone.querySelector('.settings-box');
        // if (settingsBox) {
        //   settingsBox.remove();
        // }
       // Extract background image if it exists
       if (patternLayer) {
        // Remove the existing pattern layer
        patternLayer.remove();
        
        // Create a new pattern layer with explicit styling
        const newPatternLayer = document.createElement('div');
        newPatternLayer.style.cssText = `
          position: absolute;
          inset: 0;
          background-image: url("${template?.patternUrl}");
          background-repeat: repeat;
          background-color: ${currentColorPalletes.third_color};
          mask-image: ${i==='0' ? 'none' :  `url("${template?.patternUrl}")`  };
          -webkit-mask-image: ${i==='0' ? 'none' : `url("${template?.patternUrl}")`  };
          opacity: 0.05;
          z-index: ${i===0 ? '-10' : '1'};
          pointer-events: none;
        `;
        
        // Insert the new pattern layer at the same position
       slideClone.insertBefore(newPatternLayer, slideClone.firstChild);
      }
      const computedStyle = window.getComputedStyle(slide);
      const backgroundImage = computedStyle.backgroundImage;
        // Style the cloned slide
        slideClone.style.cssText = `
          width: 100%;
          height: 100%;
          margin: 0;
          padding-top: 20px;
          transform: scale(1);
          position: relative;
          overflow: hidden;
          background-color: ${currentColorPalletes.first_color};
        `;
      console.log('currentColorPalletes:',currentColorPalletes);
        // Add this new code to ensure text contrast
        // const ensureTextContrast = (element) => {
        //   const textElements = element.querySelectorAll('p, span, div');
        //   textElements.forEach(el => {
        //     const style = window.getComputedStyle(el);
        //     console.log('style:',style);
        //     el.style.color = style.color;
        //     el.style.opacity = '1';
        //     // Force color to be fully opaque
        //     if (el.style.color.includes('rgba')) {
        //       el.style.color = el.style.color.replace('rgba', 'rgb').replace(/,[^,]*\)/, ')');
        //     }
        //   });
        // };
       
        if (i === 0 && showFaintBackgroundImages) {
                    // Create a container for background layers
            const bgContainer = document.createElement('div');
            bgContainer.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 0;
            `;

            // First layer: Background Image
            const bgImageDiv = document.createElement('div');
            bgImageDiv.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-image: url("${faintBackgroundImageUrl}");
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
              opacity: 0.2;
            `;

            // Second layer: Color Overlay
            const bgColorDiv = document.createElement('div');
            bgColorDiv.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: ${currentColorPalletes.first_color};
              mix-blend-mode: multiply;
            `;

            // Stack the layers
            bgContainer.appendChild(bgImageDiv);
            bgContainer.appendChild(bgColorDiv);
            
            // Add the background container to the slide
            slideClone.insertBefore(bgContainer, slideClone.firstChild);

          // Ensure the content div has proper z-index
          const contentDiv = slideClone.querySelector('.relative.z-10');
          if (contentDiv) {
            contentDiv.style.zIndex = '10';
            contentDiv.style.position = 'relative';
          }

          slideClone.style.backgroundColor = currentColorPalletes.first_color;
        }
        // Append elements
        container.appendChild(slideClone);
        document.body.appendChild(container);

        


        if (taglineFontCSS) {
          let existingStyle = document.head.querySelectorAll(`.tagStyle`);
          let existingStyle2 = document.querySelectorAll(`.tagStyle`);
          console.log('existingStyle:',existingStyle, 'existingStyle2:',existingStyle2, typeof existingStyle, typeof existingStyle2);
          if (existingStyle.length > 0) {
            existingStyle.forEach(style => style.remove()); // Remove existing style if found
          }
          if (existingStyle2.length > 0) {
            existingStyle2.forEach(style => style.remove()); // Remove existing style if found
          }
          const styleTagline = document.createElement('style');
          styleTagline.textContent = taglineFontCSS;
          styleTagline.classList.add('tagStyle');
          document.head.appendChild(styleTagline);
        }
      
        if (paragraphFontCSS) {
          let existingStyle = document.head.querySelectorAll(`.paraStyle`);
          let existingStyle2 = document.querySelectorAll(`.paraStyle`);
          console.log('existingStyle:',existingStyle, 'existingStyle2:',existingStyle2);
          if (existingStyle.length > 0) {
            existingStyle.forEach(style => style.remove()); // Remove existing style if found
          }
          if (existingStyle2.length > 0) {
            existingStyle2.forEach(style => style.remove()); // Remove existing style if found
          }
          const styleParagraph = document.createElement('style');
          styleParagraph.textContent = paragraphFontCSS;
          styleParagraph.classList.add('paraStyle');
          document.head.appendChild(styleParagraph);
        }
       // document.head.appendChild(link1);
       // document.head.appendChild(link2);
       
      // Wait for elements to be properly rendered
      await new Promise(resolve => setTimeout(resolve, 100));
      // Wait for elements to be properly rendered

        try {
          // Use html-to-image to capture the slide
          const dataUrl = await htmlToImage.toJpeg(container, {
            quality: 1.0,
            width: pageWidth,
            height: pageHeight,
            pixelRatio: 2,
            skipAutoScale: true,
           
            //skipFonts:true,
            //fontEmbedCSS: await htmlToImage.getFontEmbedCSS(container),
            backgroundColor: window.getComputedStyle(slide).backgroundColor,
            style: {
              transform: 'scale(1)',
              transformOrigin: 'top left',
              width: `${pageWidth}px`,
              height: `${pageHeight}px`,
              //WebkitPrintColorAdjust: 'exact',
              //colorAdjust: 'exact'
            },
            imagePlaceholder: undefined,
            cacheBust: true,
            // fetchRequestInit: { // This helps with CORS issues for images
            //   mode: 'cors',
            //   credentials: 'include',
            // },
            filter: (node) => {
              // if (node.tagName === 'P' || node.tagName === 'SPAN' || node.tagName === 'DIV') {
              //   const style = window.getComputedStyle(node);
              //   node.style.color = style.color;
              //   node.style.opacity = '1';
              // }
              if (node.classList?.contains('pattern_layer')) {
                node.style.opacity = '0.1';
                return true;  // Force lighter opacity
              }else if (node.tagName === 'P' || node.tagName === 'SPAN' || node.tagName === 'DIV') {
                const style = window.getComputedStyle(node);
                node.style.color = style.color;
                node.style.opacity = '1';
                return true;
              }
              return true;
            }
          });

          // Add new page if not first slide
          if (i > 0) {
            pdf.addPage();
          }

          // Add to PDF
          pdf.addImage(
            dataUrl,
            'JPEG',
            0,
            0,
            pageWidth,
            pageHeight,
            undefined,
            'FAST'
          );

          // Cleanup
          document.body.removeChild(container);
          onlyRemove(taglineFontCSS, paragraphFontCSS);
         // Clears all styles, scripts, and meta tags

        } catch (error) {
          console.error('Error capturing slide:', error);
          document.body.removeChild(container);
          onlyRemove(taglineFontCSS, paragraphFontCSS);
          // Clears all styles, scripts, and meta tags

        }
      }

      // Save the PDF
      pdf.save('carousel-slides.pdf');
      message.destroy();
      message.success('PDF exported successfully!');
      
    } catch (error) {
      console.error('Error exporting PDF:', error);
      message.destroy();
      message.error('Failed to export PDF. Please try again.');
    }
  };
  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }
  return (
    <>
      {/* <Modal
        title="📱 Better View Available!"
        open={showRotateModal}
        onOk={() => setShowRotateModal(false)}
        onCancel={() => setShowRotateModal(false)}
        centered
      >
        <p>Rotate your device horizontally for a better editing experience! 🔄</p>
      </Modal> */}

      <div className='min-h-screen bg-gray-50'>
       
        {/* Header Bar */}
        <div className='flex justify-between items-center h-20 px-6 bg-white border-b border-gray-200 shadow-sm'>
          <div className='flex items-center gap-4'>
            <Link to="/" className='text-gray-600 hover:text-purple-600 transition-colors'>
              <ArrowLeftOutlined className='text-lg' />
            </Link>
            <div>
              <h2 className='text-xl font-semibold bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent'>
                Carousel Maker
              </h2>
              <span className='text-sm text-gray-500'>Create engaging LinkedIn carousels</span>
            </div>
          </div>
          
          {!isMobile ? (
            <div className='flex gap-4'>
              {/* {userData.subscription === false ? (
                <Tooltip title="Trial expired. Please subscribe to continue.">
                  <Button icon={<ExclamationCircleOutlined/>} className='flex items-center gap-2 hover:text-purple-600 hover:border-purple-600'>
                    Trial Remaining: {trial}
                  </Button>
                </Tooltip>
              ) : null} */}
              <Tooltip title="Click to see subscription status">
                <Button 
                  icon={<CrownOutlined />}
                  onClick={() => navigate('/settings')}
                  className='flex items-center gap-2 hover:text-purple-600 hover:border-purple-600'
                >
                  Subscription Status : {userData?.subscription ? 'Pro' : 'Free'}
                </Button>
              </Tooltip>
              <Tooltip title="Export as PDF">
                <div className="flex gap-2">
                  <Button 
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={exportToPDFUsingHtmlToImage}
                    className='flex items-center gap-2 bg-gradient-to-r from-purple-600 to-pink-500 border-none hover:from-purple-700 hover:to-pink-600'
                  >
                    Export (as PDF)
                  </Button>
                </div>
              </Tooltip>
            </div>
          ) : (
            <div className="relative">
              {/* Hamburger Button */}
              <Button
                icon={showMobileMenu?<CloseOutlined/>:(<MenuOutlined/>)}
                onClick={() => setShowMobileMenu(!showMobileMenu)}
                className="flex items-center justify-center p-2"
              />

              {/* Mobile Dropdown Menu */}
              {showMobileMenu && (
                <div className="absolute right-0 top-12 w-64 bg-white rounded-lg shadow-xl border border-gray-100 py-2 z-50">
                  {userData.subscription === false && (
                    <div className="px-4 py-2 hover:bg-purple-50 flex items-center gap-2 cursor-pointer">
                      <ExclamationCircleOutlined className="text-purple-600" />
                      <span>Trial: {trial} remaining</span>
                    </div>
                  )}
                  
                  <div 
                    className="px-4 py-2 hover:bg-purple-50 flex items-center gap-2 cursor-pointer"
                    onClick={() => navigate('/settings')}
                  >
                    <CrownOutlined className="text-purple-600" />
                    <span>{userData?.subscription ? 'Pro User' : 'Free User'}</span>
                  </div>

                  <div 
                    className="px-4 py-2 hover:bg-purple-50 flex items-center gap-2 cursor-pointer"
                    onClick={exportToPDFUsingHtmlToImage}
                  >
                    <DownloadOutlined className="text-purple-600" />
                    <span>Export PDF</span>
                  </div>
                </div>
              )}
            </div>
          )}

        </div>

       {/* second header in case of mobile */}
       {isMobile?(<div className='flex justify-between items-center h-20 px-6 bg-white border-b border-gray-200 shadow-sm'>
        <div className='flex items-center gap-4'>
        <Button
                icon={showSettingsMenu?<CloseOutlined/>:(<MenuOutlined/>)}
                onClick={() => setShowSettingsMenu(!showSettingsMenu)}
                className="flex items-center justify-center p-2"
              />

              {showSettingsMenu && (
                //show <SideScreen /> 
                <div className="absolute left-0 top-40 w-64 bg-white rounded-lg shadow-xl border border-gray-100 py-2 z-50">
                  <SideScreen isMobile={isMobile} subscription={subscription} userData={userData} />
                </div>
              )}
        </div>
       </div>):<></>}

       {/* second header in case of mobile */}


        {/* Main Content */}
        <div className='flex h-[calc(100vh-5rem)]'>
          {/* Left Sidebar */}
          {isMobile ? null : (
          <div className='w-96 bg-white border-r border-gray-200 overflow-y-auto'>
            <SideScreen subscription={subscription} userData={userData} />
          </div>
          )}
          {/* Main Canvas Area */}
          <div className='flex-1 overflow-y-auto overflow-x-hidden p-8 bg-gradient-to-br from-gray-50 to-purple-50/30'>
            <div className="max-w-6xl mx-auto" ref={sliderRef}>
              <SlideScreen isMobile={isMobile} userData={userData} />
            </div>
          </div>
        </div>

        {
          userData?.subscription===false && userData?.trial === 0 ? (
            <Modal
              title="Subscription Status"
              open={true}
              onCancel={() => navigate('/settings')}

              onOk = {()=>navigate('/settings')}  
            >
              <p>🚫 Trial Expired! 🚫</p>

              <p>🔓 Free users can't access core features. Don't miss out!</p>

              <p>🔥 Upgrade to Pro for complete access! 🔥</p>

              <p>👉 Subscribe Now! 🚀</p>
            </Modal>
          ) : null
        }
      </div>
    </>
  );
};

export default EditScreen;
